export default __webpack_public_path__ + "static/media/collapseSideMenu.c3e462ca.svg";